<template>
  <transition name="fade">
    <div class="question single-option boolean question box box-shadow">

      <div class="question--question" v-html="question"></div>

      <div class="answers row">

        <div v-for="col in partitionedAnwsers" class="col-12 col-sm-6 col-lg-4">
          <div v-for="answer in col" class="row">
            <div class="form-checkbox ">
              <input
                      type="radio"
                      :name="index+'-'+answer.id"
                      :id="index+'-'+answer.id"
                      :value="answer.id"
                      v-model="radioButtonValue"
              />
              <label class="small-label" :for="index+'-'+answer.id" v-html="answer.answer"></label>
            </div>
          </div>
        </div>



      </div>
      <footer>Q ID: {{id}} : {{index}}</footer>
    </div>
  </transition>
</template>

<script>
  import Question from '@/components/questions/Question'
  export default {
    name: 'SingleOption',
    extends: Question,
    data: function () {
      return {
        temp: []
      }
    },
    computed: {
      radioButtonValue: {
        get: function () {
          return this.value[0]
        },
        set: function (val) {
          this.$emit('input', [val])
        }
      },
      partitionedAnwsers () {
        let items = this.answers
        let chunkSize = Math.ceil(items.length / 3)

        let groups = []
        for (let i = 0; i < items.length; i += chunkSize) {
          groups.push(items.slice(i, i + chunkSize))
        }
        return groups
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/questions/SingleOption.vue